import React from "react";
import { isSet,convertStrToArrWithSeparator } from "../../Utils/CommonFunctions";


export const stepsProcessFieldTypes = {
    'PICKLIST':'PickList',
    'EMAIL':'Email',
    'MAPPING':'Mapping',
    'TEXTAREA':'TextHTML',
    'RADIO':'Radio',
    'CONDITIONS':'Conditions',
    'TEXTINPUT':'TextInput',
    'DIRECTORY':'Directory',
    'MULTISELECT':'MultiChoose',
    'DATEPICK':'DatePick',
    "CHECKBOX":"OnAndOffField",
    "Number":"Number",
    "HIDDEN":"Hidden",
    "Hidden":"Hidden",
    "hidden":"Hidden"
}

export const getVariableDisplayValue = (fieldDetails,value,obj={})=>{
    //console.log('fieldDetails',fieldDetails,value,obj);
    //let selectedValue = getVariableDisplayValueWithAbsolute(fieldDetails,value);
    let selectedValue = Array.isArray(value)=== false?getVariableDisplayValueWithAbsolute(fieldDetails,value,obj):value;    
    //console.log('selectedValue get',selectedValue);
    if(selectedValue.length>0){
        return selectedValue;
    }
    try{
        fieldDetails.fields_with_filters.window_fields.map((item)=>{
            if(value.indexOf(item.window_field_id_path)!==-1){
                selectedValue.push({...item,dependent_layout:{...isSet(item.dependent_layout,{}),layoutFields:isSet(fieldDetails.layoutFields,{})}});
                if(item.dependent_layout){
                    const returnValue = getVariableDisplayValue(item.dependent_layout,value);
                    selectedValue = [
                        ...selectedValue,
                        ...returnValue
                    ]
                }
            }else if(value.indexOf(item.window_field_id_path)!==-1){
                selectedValue.push({...item,dependent_layout:{...isSet(item.dependent_layout,{}),layoutFields:isSet(fieldDetails.layoutFields,{})}})
            }else {
                if(item.dependent_layout){
                    const returnValue = getVariableDisplayValue(item.dependent_layout,value);
                    selectedValue = [
                        ...selectedValue,
                        ...returnValue
                    ]
                }
            }
        })
    }catch(e){

    }
    // console.log('fieldDetails',selectedValue);
    
    return selectedValue;
}
export const getVariableDisplayValueWithAbsolute  = (fieldDetails,value,obj={})=>{
    let selectedValue = [];
    const valueInArr = convertStrToArrWithSeparator(value,'.');    
    try{
        //console.log('selectedValue', fieldDetails.fields_with_filters.window_fields,valueInArr,obj);
        // valueInArr.map((val)=>{
        if(valueInArr.length>0){
            fieldDetails.fields_with_filters.window_fields.map((item)=>{
                if(item.dependent_layout){
                    if(valueInArr[0]===isSet(item.dependent_layout.window_id,null) || item.id===valueInArr[0]){
                        selectedValue.push({...item,dependent_layout:{...isSet(item.dependent_layout,{}),layoutFields:isSet(fieldDetails.layoutFields,{})}});
                        valueInArr.shift();
                        const returnValue = getVariableDisplayValueWithAbsolute(item.dependent_layout, valueInArr.join('.'));
                        selectedValue = [
                            ...selectedValue,
                            ...returnValue
                        ]
                    }
                }else{
                    if(item.id===valueInArr[0]){
                        // valueInArr.shift();
                        selectedValue.push({...item,dependent_layout:{...isSet(item.dependent_layout,{}),layoutFields:isSet(fieldDetails.layoutFields,{})}});
                    }
                }
            });
        }
    }catch(e){

    }
    // console.log('selectedValue',selectedValue,valueInArr);
    return selectedValue;
}

export const getLayoutFieldsData =  (layoutFields,id,inputType='TextInput',returnData={
    isExist:false,
    fieldData:{}
})=>{
    
    const ids = convertStrToArrWithSeparator(id,'.');
    const fieldId = isSet(ids,[]).pop();
    isSet(layoutFields,[]).map((field)=>{
        if(returnData.isExist===true){return false}
        if(field.id===fieldId){
            let fieldType = isSet(field.field_type,isSet(field.fieldtype_name,isSet(field.field_type_name,'TextInput')));
            //console.log('field.is_subform==',field.is_subform)
            let isDaysAgo = false;
            if(fieldType==='Date' || fieldType==='DateTime'){
                // console.log('inputtype...',inputType);
                if(isSet(inputType,'TextInput')==='Integer'){
                    isDaysAgo = true;
                    fieldType = 'Number';
                }
            }
            const isSubform = isSet(field.is_subform,false);
            returnData = {
                isExist:true, 
                fieldData:{
                    ...field,
                    isDaysAgo:isDaysAgo,
                    element:(fieldType==="AutoNumber")?'TextInput':(isSubform === true)?'SubForm':fieldType,
                    //element:(fieldType==="AutoNumber" || isSubform === true)?'TextInput':fieldType,
                    itemIndex:0,
                    is_status_picklist:isSet(field.is_status_picklist,false),
                    order_by_asc:isSet(field.order_by_asc,false),
                    is_add_form:true,
                    files:[],
                    reminder:{},
                    required:isSet(field.is_required,false),
                    options:isSet(field.options,[]).map((option)=>{
                        return{
                            id:option.key,
                            value:option.value,
                            display_index:0,
                        }
                    }),
                    value:isSet(field.lookup_window_name,null),
                    label:{
                        blocks:[{text: field.field_name, entityRanges: []}]
                    }
                }
            }
        }
        try{
            if(returnData.isExist===false){
                returnData = getLayoutFieldsData(field.dependent_layout.fields_with_filters.window_fields,fieldId,inputType,returnData);
            }
        }catch(e){
            
        }
    })
   
    return returnData
   }

export const getResourcesVariables = (resourcesList,currentApiName='',arrayObjectFields,isCollectionAlso=true,filterBy='')=>{
    let appendVariables =[];
    if(isCollectionAlso===true){
        try{
            Object.entries(resourcesList['COLLECTION']).map(([key,val])=>{
                // console.log(val.dependent_layout,'yes in',val,resourcesList['COLLECTION'])

                if(val.fields_with_filters!==null && val.fields_with_filters!==undefined){
                    appendVariables.push({
                        field_name:key,
                        field_id:'',
                        id:val.data_id,
                        dependent_layout:{
                            ...val,
                            id:val.data_id,
                            fields_with_filters:{
                                ...val.fields_with_filters,
                                window_fields:val.fields_with_filters.window_fields.filter((item)=>{                                    
                                    if(item.field_name!==currentApiName){
                                        return item;
                                    }
                                })
                            }
                        }
                    })
                }else{
                    appendVariables.push({
                        field_name:key,
                        field_id:'',
                        id:val.data_id,
                        dependent_layout:{
                            ...val,
                            id:val.data_id,
                            fields_with_filters:{                            
                                window_fields:[]
                            }
                        }
                    })      
                }                
            })
        }catch(e){
    
        }
    }
    let updateResourcesList = [...resourcesList['constants'],...resourcesList['variables']].filter((itm)=>{
        if(filterBy==='' || isSet(itm.variable_name,isSet(itm.name,'')).indexOf(filterBy)===-1){
            return itm;
        }
    })
    //console.log('updateResourcesList',updateResourcesList);
    // console.log('appendVariables==',appendVariables)
    return {
        display_name:'Resources',
        fields_with_filters:{
            window_fields:mergingArrayObjectList([
                ...appendVariables,
                ...[...updateResourcesList].map((itm)=>{
                    return{
                        ...itm,
                        is_variable_or_constant:true,
                        window_field_id_path:itm.id,
                        window_field_name_path:isSet(itm.api_field_name,itm.field_name)
                    }
                })
            ],arrayObjectFields,false),
        }
    }
}   

export const mergingArrayObjectList = (fieldsArr,arrayObjectFields={},isAllowArray=false,is_variable_or_constant=false)=>{
    //console.log('mergingArrayObjectList==',fieldsArr)
    let arrayVariables = [];
    let isVariableOrConstant = is_variable_or_constant;
    fieldsArr.map((item)=>{
        let dependent_layout = isSet(item.dependent_layout,null);   
        // || isSet(item.fieldtype_name,item.field_type_name)==='Array'
        if( (isAllowArray===false && (isSet(item.fieldtype_name,item.field_type_name)==='Object' || isSet(item.fieldtype_name,item.field_type_name)==='Messages' || isSet(item.fieldtype_name,item.field_type_name)==='Array') ) || (isAllowArray===true && (isSet(item.fieldtype_name,item.field_type_name)==='Object' || isSet(item.fieldtype_name,item.field_type_name)==='Messages' || isSet(item.fieldtype_name,item.field_type_name)==='Array') )){
            // if(filterField.indexOf(isSet(item.fieldtype_name,item.field_type_name))!==-1){
                const fields = isSet(arrayObjectFields[item.id],isSet(item['fields'],[]));
                dependent_layout = {
                    display_name: item.variable_name,
                    fields_with_filters:{
                        window_fields:mergingArrayObjectList(fields,{},true,true)
                    }
                }
                isVariableOrConstant = true; 
            }else{
                isVariableOrConstant = isSet(item.is_variable_or_constant,isSet(isSet(item.dependent_layout,{is_variable_or_constant:false}).is_variable_or_constant,false));
                // isVariableOrConstant = isSet(item.dependent_layout,{is_variable_or_constant:false}).is_variable_or_constant;
            }
        arrayVariables.push({
            //  api_field_name:isSet(item.variable_name,isSet(item.name,item.field_name)),
            ...item,
            dependent_layout:dependent_layout,
            field_name:isSet(item.variable_name,isSet(item.name,item.field_name)),
            api_field_name:isSet(item.api_field_name,isSet(item.variable_name,isSet(item.name,''))),
            field_id:item.id,
            fieldTypeId:item.fieldtype_id,
            filters:item.filters,
            window_field_id_path:item.id,
            is_variable_or_constant:isVariableOrConstant,
            window_field_name_path:item.variable_name,
        });
    })
    // console.log('arrayVariables',arrayVariables);
    return arrayVariables;
}


export const lookupFieldDataFromGroups = (lookupFieldsPayload)=>{
    //console.log('lookupFieldsPayload===',lookupFieldsPayload)
    let fieldsArr = [];
    let valuesObject = isSet(lookupFieldsPayload.valuesObject,{});
    // console.log('lookupFieldsPayload1111',valuesObject);
    try{
      if(lookupFieldsPayload.dependent_layout!==null){
        lookupFieldsPayload.dependent_layout.fields_with_filters.window_fields.map((field)=>{
            const fieldType = isSet(field.field_type,isSet(field.fieldtyspe_name,'TextInput'));
            if(fieldType==='Lookup' || fieldType==='MultiLookup' || fieldType==="AutoNumber" || field.assign_field===false){
            //if(fieldType==="AutoNumber" || field.assign_field===false){
                return false;
            }
            // if(Object.entries(isSet(lookupFieldsPaylssoad.valuesObject,{})).length===0){
            //     valuesObject = {
            //         ...valuesObject,
            //         [field.id]:[{ //api_field_name
            //             name:'',
            //             value:'',
            //             data_id:null,
            //             is_loop:false,
            //             is_window_field:false,
            //             is_variable_or_constant:false,
    
            //         }]
            //     }
            // }
          
            fieldsArr.push({
                    ...field,
                    element:(fieldType==="AutoNumber")?'TextInput':fieldType,
                    itemIndex:0,
                    is_status_picklist:isSet(field.is_status_picklist,false),
                    order_by_asc:isSet(field.order_by_asc,false),
                    is_add_form:true,
                    files:[],
                    reminder:{},
                    required:isSet(field.is_required,false),
                    options:isSet(field.options,[]).map((option)=>{
                        return{
                            id:option.key,
                            value:option.value,
                            display_index:0,
                        }
                    }),
                    value:isSet(field.lookup_window_name,null),
                    label:{
                        blocks:[{text: field.field_name, entityRanges: []}]
                    }
                })
        })
      }
    }catch(e){

    }
    // console.log('fieldsArr',fieldsArr,valuesObject);
    return {lookupFields:lookupFieldsPayload,fieldsArr:fieldsArr,valuesObject:valuesObject};
}

export const getAndArrageValuesAsString  = (lhs,filterObj,rhs,logicalOperator,fieldType)=>{
    const {id} = filterObj;
    let filters = (filterObj?.filters!=undefined)?filterObj.filters:[];
    const indexing = filters.findIndex((i=>i.filterId===id));
    const operator = (indexing!==-1)?filters[indexing]['name']:'';
    let lhsArr = [];
    // console.log('data...',lhs,filterObj,rhs);
    isSet(lhs,[]).map((item)=>{
        lhsArr.push(item.field_name);
    });
    let rhsArr = [];
    rhs.map((itm)=>{
        // if(itm.is_lookup===true){
        //     rhsArr.push('New Record Added');
        // }else if(isSet(itm.is_loop,false)===true || isSet(itm.is_variable_or_constant,false)===true){
        //     rhsArr.push(itmVal.name);
        // }else if(isSet(itmVal.is_expression,false)===true){
        //     rhsArr.push(itmVal.name);
        // }else{
            if(itm.isObjectOrArray && itm.isObjectOrArray === true) {
                rhsArr.push("Manually Created");
            }else {
                if(fieldType === 'DateTime'){
                    // const dateFormat = (isSet(getDateFormat('DateTime'),null)!==null)?getDateFormat('DateTime'):'YYYY-MM-DDTHH:mm:ss';
                    // let dispValue = '';
                    // if(dateFormat==='UNIX'){
                    //   dispValue = (isSet(itm.value,null)!==null)?moment(itm.value):'';//.format(getDateFormat())
                    // }else{
                    //   dispValue = (isSet(itm.value,null)!==null)?moment(itm.value, dateFormat,true):'';//.format(getDateFormat())
                    // }
                    // console.log('dispValue==',dispValue)
                    let dispValue = isSet(itm.name,itm.value);
                    dispValue = dispValue.slice(0,-2);
                    rhsArr.push(dispValue);
                }else if(fieldType === 'Date'){
                    let dispValue = isSet(itm.name,itm.value);
                    dispValue = dispValue.slice(0,-10);
                    rhsArr.push(dispValue);
                }else{
                    rhsArr.push(isSet(itm.name,itm.value));    
                }                  
            }
            
        // }
    })
    return{
        lhs:' '+lhsArr.join('-'),
        operator:' '+operator,
        rhs:' '+rhsArr.join('-'),
        logicalOperator:logicalOperator,
    }
    // return  <>
    //         <span className="text-small mb-0">
    //         {lhsArr.join('-')}
    //         </span>
    //         <span className="text-small text-danger mb-0">
    //         {operator}
    //         </span>
    //         <span className="text-small mb-0">
    //         {rhsArr.join('-')}
    //         </span>
    //         </>
    // console.log('lhs',lhsArr,operator,rhsArr);
    // console.log('filter..',filters,id);
    // filters.findIndex(
}

export const arrangeRecordConditionValues = (payload,windowFields)=>{
    const {properties} = payload;
    const drillDownOptions = isSet(windowFields[properties.data.window_id],{});
    let updateValueAsString = [];
    isSet(isSet(properties.data,{conditions:[]}).conditions,[]).map((con,conIndex)=>{
        let filters = [];
        const splitedWindow = convertStrToArrWithSeparator(isSet(con.absolute_window,''),'.')
        splitedWindow.push(con.tableDescriptorId);
        const displayValue = getVariableDisplayValue(drillDownOptions,splitedWindow.join('.'));
        if(displayValue.length>0){
            filters = displayValue[(displayValue.length-1)].filters;
        }
        const valueAsStr =  getAndArrageValuesAsString(displayValue,{filters:filters,id:con.filter_id},con.value,isSet(con.logical_operator,'AND'),isSet(con.field_type_name,''));
        updateValueAsString.push(valueAsStr);
    })
    return updateValueAsString;
}

export const arrangeRecordConditionValuesForLoop = (payload,drillData)=>{
    const {properties} = payload;
    const drillDownOptions = isSet(drillData,{});
    let updateValueAsString = [];
    isSet(isSet(properties.data,{conditions:[]}).conditions,[]).map((con,conIndex)=>{
        let filters = [];
        const splitedWindow = convertStrToArrWithSeparator(isSet(con.absolute_window,''),'.')
        splitedWindow.push(con.tableDescriptorId);
        const displayValue = getVariableDisplayValue(drillDownOptions,splitedWindow.join('.'));
        if(displayValue.length>0){
            filters = displayValue[(displayValue.length-1)].filters;
        }
        const valueAsStr =  getAndArrageValuesAsString(displayValue,{filters:filters,id:con.filter_id},con.value,isSet(con.logical_operator,'AND'));
        updateValueAsString.push(valueAsStr);
    })
    return updateValueAsString;
}

export const arrangeRecordConditionValuesForAction = (payload,lookupData,fieldKey)=>{
    
    const {properties} = payload;
    const drillDownOptions = isSet(lookupData,{});
    let updateValueAsString = [];
    isSet(isSet(properties.se_action.data[fieldKey],{value:[]}).value,[]).map((con,conIndex)=>{
        let filters = [];
        const splitedWindow = convertStrToArrWithSeparator(isSet(con.absolute_window,''),'.')
        splitedWindow.push(con.tableDescriptorId);
        const displayValue = getVariableDisplayValue(drillDownOptions,splitedWindow.join('.'));
        if(displayValue.length>0){
            filters = displayValue[(displayValue.length-1)].filters;
        }
        const valueAsStr =  getAndArrageValuesAsString(displayValue,{filters:filters,id:con.filter_id},con.value,isSet(con.logical_operator,'AND'));
        updateValueAsString.push(valueAsStr);
    })
    return updateValueAsString;
}
